import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { NavController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class NotVerifiedGuard implements CanActivate {
    constructor(private navCtrl: NavController, private api: ApiService) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const currentUser = this.api.currentUserValue;
        if (!currentUser?.verified) {
            return true;
        }

        return this.navCtrl.navigateRoot('/tabs');
    }
}
